import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { focusVisible } from '@cld/style-utils';
import theme, { combineValues } from '@cld/theme-helper';
import './toggle.theme';

const t = theme({
  basePath: 'components.toggle',
});

export interface RootProps {
  isOn: boolean;
  disabled?: boolean;
  danger?: boolean;
  tabIndex?: number;
}

export interface PillProps {
  isOn: boolean;
  disabled?: boolean;
}

export const Root = styled.div<RootProps>`
  width: ${t`width`};
  height: ${t`height`};
  border-radius: ${t`border.radius`};
  background-color: ${t`background.color.inactive`};
  padding: ${t`padding`};
  transition: 0.2s;
  cursor: pointer;

  outline: none;
  &${focusVisible()} {
    box-shadow: ${t`focus.boxShadow.sizes`} ${combineValues(t`focus.boxShadow.baseColor`, (color: string) => rgba(color, 0.5))},
      inset 0 0 0 1px ${t`focus.boxShadow.baseColor`};
  }

  ${(props) =>
    props.isOn &&
    css`
      background-color: ${t`background.color.active`};
    `}

  ${(props) =>
    props.danger &&
    css`
      background-color: ${t`background.color.error`};
    `}

  ${(props) =>
    props.disabled &&
    css`
      background-color: ${t`background.color.disabled`};
      cursor: not-allowed;
    `}
`;

export const Pill = styled.div<PillProps>`
  width: ${t`Pill.width`};
  height: ${t`Pill.height`};
  background-color: ${t`Pill.background.color.inactive`};
  border-radius: 100%;
  transform: translateX(${t`Pill.position.inactive`});
  transition: 0.2s;
  pointer-events: none;

  ${(props) =>
    props.isOn &&
    css`
      transform: translateX(${t`Pill.position.active`});
      background-color: ${t`Pill.background.color.active`};
    `}

  ${(props) =>
    props.disabled &&
    css`
      background-color: ${t`Pill.background.color.disabled`};
    `}
`;
